import { render, staticRenderFns } from "./Sable.vue?vue&type=template&id=3c237cb4&scoped=true&"
import script from "./Sable.vue?vue&type=script&lang=ts&"
export * from "./Sable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c237cb4",
  null
  
)

export default component.exports